import withoutAuth from './withoutAuth';

export default {
  withoutAuth,
};
